var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBoxIcon22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_172)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3972 0.139774C11.2957 0.0449072 11.1793 -0.00625706 11.0492 0.0012044C10.919 0.0012044 10.8027 0.0523687 10.7085 0.154697L9.93937 0.958403L12.0933 3.05507L12.8688 2.23645C12.963 2.14158 12.9989 2.01687 12.9989 1.88576C12.9989 1.75465 12.9482 1.62994 12.854 1.54253L11.3972 0.139774ZM0.883382 0.542693H6.19425V1.93266H1.54248C1.49805 1.93266 1.45679 1.95184 1.42716 1.98169C1.39754 2.01154 1.3785 2.05311 1.3785 2.09788V11.4471C1.3785 11.4919 1.39754 11.5334 1.42716 11.5633C1.45679 11.5931 1.49805 11.6123 1.54248 11.6123H10.8217C10.8661 11.6123 10.9074 11.5931 10.937 11.5633C10.9666 11.5334 10.9857 11.4919 10.9857 11.4471V6.9393H12.3652V12.1101C12.3652 12.3563 12.2647 12.577 12.105 12.7379C11.9452 12.8989 11.7231 13.0001 11.4819 13.0001H0.883382C0.63794 13.0001 0.420003 12.8989 0.260254 12.7379C0.100505 12.578 0 12.3531 0 12.1101V1.43274C0 1.18545 0.100505 0.965865 0.260254 0.804911C0.418945 0.643956 0.642171 0.542693 0.883382 0.542693ZM7.3654 8.00202C7.08293 8.09689 6.79199 8.1843 6.50952 8.28023C6.22705 8.3751 5.94352 8.46996 5.65365 8.56483C4.97868 8.78441 4.60946 8.90806 4.52905 8.93044C4.44971 8.95283 4.50049 8.63838 4.66659 7.98071L5.20296 5.91282L5.2474 5.86698L7.3654 8.00096V8.00202ZM6.03133 5.04622L9.35645 1.56705L11.5104 3.65626L8.14828 7.17913L6.03133 5.04622Z",
    fill: "#5F5F5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBoxIcon22);
export default __webpack_public_path__ + "static/media/edit-box-icon (2) 2.b4a57acfa4913ff74a9fa6ea51cd937e.svg";
export { ForwardRef as ReactComponent };